import { ServiceOptions } from "./ServiceOptions";

export const BookingStepOne = () => {
  // Step Two: Here the user chooses the types of services
  // he/she wants to book an appointment for based on the location input.

  // LOCAL STATE:

  // FETCH DATA:
 
  // LOCAL VARIABLES:

  // USE EFFECTS:
  
  
  // HANDLERS & FUNCTIONS:

    
  return (
    <>
      <div className="flex flex-row w-full max-sm:flex-col max-sm:items-center gap-6 min-w-[80%] ">
        <div className="flex flex-col gap-6 w-full items-start">
          <h4 className="pt-4">Πώς θέλεις να εξυπηρετηθείς;</h4>
          <ServiceOptions/>
        </div>
      </div>
    </>
  );
};
